<template>
  <div>
    <PageAllow
      controller="StockTakes"
      :action="isNew ? 'add' : isView ? 'view' : mode"
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color pa-4">
      <v-expansion-panels v-model="panels" multiple accordion>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <v-card-title class="ms-n4 py-0">
              {{
                $t(isNew ? "CRUD.newInfo" : "CRUD.info", [
                  mode == "regularNew"
                    ? $t("StockTakes.regularStakeOrder")
                    : $t("StockTakes.ObjectName"),
                ])
              }}
              <v-chip
                v-if="stockTakeOrder.cancel_flg"
                small
                label
                outlined
                class="ms-4 mt-1"
                color="danger"
              >
                {{ $t("CRUD.cancelled") }}
              </v-chip>
              <v-chip
                v-if="!isNew"
                small
                label
                class="ms-4 mt-1"
                :color="stockTakeOrder.status | stockTakeOrderStatusColor"
                :text-color="
                  stockTakeOrder.status | stockTakeOrderStatusTextColor
                "
                >{{ stockTakeOrder.status | stockTakeOrderStatusText }}
              </v-chip>
              <span
                class="text-no-wrap caption secondary--text ml-1"
                v-if="stockTakeOrder.term_date"
              >
                ({{ $t("StockTakes.Fields.term_date")
                }}{{ stockTakeOrder.term_date | formatTime }})
              </span>
              <v-spacer />
              <v-sheet class="pt-1 transparent-background-color d-inline-block">
                <!-- 返回修改 -->
                <v-btn
                  v-if="
                    preview &&
                    $permission.permissionAllow('StockTakes', 'stockTake')
                  "
                  small
                  dark
                  outlined
                  color="secondary"
                  class="px-2 me-2 mb-1 elevation-1"
                  @click.stop="preview = false"
                >
                  <v-icon x-small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backForModify") }}
                </v-btn>
                <!-- 保存 -->
                <v-btn
                  v-if="
                    mode == 'stockTake' &&
                    $permission.permissionAllow('StockTakes', 'edit') &&
                    stockTakeOrder.status == 1 &&
                    !preview
                  "
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="doEdit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("StockTakes.actions.edit") }}
                </v-btn>
                <!-- 提交 -->
                <v-btn
                  v-if="
                    isNew && $permission.permissionAllow('StockTakes', 'add')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="doSubmit()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("StockTakes.actions.submitOrder") }}
                </v-btn>

                <!-- 盘点提交按钮 -->
                <v-btn
                  v-if="
                    mode == 'stockTake' &&
                    $permission.permissionAllow('StockTakes', 'stockTake')
                  "
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="preview ? doSubmit() : doPreview()"
                >
                  <v-icon x-small class="pe-1">fa-save</v-icon>
                  {{ $t("StockTakes.actions.stockTake") }}
                </v-btn>
              </v-sheet>
              <StockTakeOrderActions
                v-if="isView"
                :stock_take_order="stockTakeOrder"
                showExport
                :showStockTake="
                  stockTakeOrder.actions
                    ? stockTakeOrder.actions.stock_take
                    : false
                "
                :showCancel="
                  stockTakeOrder.actions ? stockTakeOrder.actions.cancel : false
                "
                :showHistoryExport="stockTakeOrder.actions ? stockTakeOrder.actions.history_excel : false"
                detail-mode
                @stockTake="mode = 'stockTake'"
              />
              <StockTakeOrderActions
                v-if="!preview && mode == 'stockTake'"
                :stock_take_order="stockTakeOrder"
                showExport
                :showCancel="
                  stockTakeOrder.actions ? stockTakeOrder.actions.cancel : false
                "
                :showHistoryExport="stockTakeOrder.actions ? stockTakeOrder.actions.history_excel : false"
                detail-mode
              />
            </v-card-title>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
            <v-divider />
            <v-row no-gutters class="mt-4 table-style">
              <!-- 盘点单编号 -->
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakes.DetailFields.order_code")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ stockTakeOrder.stock_take_code }}
                  </span>
                </v-card>
              </v-col>
              <!-- 仓库名称 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakes.DetailFields.stock_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("StockTakes.default_stock_name") }}
                  </span>
                </v-card>
              </v-col>

              <!-- 创建时间 -->
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakes.DetailFields.created_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockTakeOrder.created | formatTime }}
                </v-card>
              </v-col>
              <!-- 操作人 -->
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakes.DetailFields.operater_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ accountUser ? accountUser.shop_user_name : "" }}
                </v-card>
              </v-col>
              <!-- 执行人 -->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakes.DetailFields.execute_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ accountUser ? accountUser.shop_user_name : "" }}
                  </span>
                </v-card>
              </v-col>
              <!-- 盘点时间 -->
              <v-col cols="12" md="4" v-if="!isNew">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakes.DetailFields.stockTakeTime")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockTakeOrder.finish_time | formatTime }}
                </v-card>
              </v-col>
              <!-- 实际发生时间-->
              <v-col cols="12" md="4" v-if="isNew">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakes.DetailFields.actual_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <SearcherDatetime
                    class="my-n2"
                    v-model="stockTakeOrder.actual_date"
                    type="datetime"
                    single-line
                    dense
                    hide-details
                  >
                  </SearcherDatetime>
                </v-card>
              </v-col>
              <!-- 盘点实际发生时间 -->

              <v-col cols="12" md="4" v-if="mode == 'stockTake' && preview">
                <ValidationObserver ref="observer">
                  <ValidationProvider
                    v-slot="{ errors }"
                    rules="required"
                    :name="$t('StockTakes.DetailFields.time')"
                  >
                    <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                      <span class="secondary--text">
                        {{ $t("StockTakes.DetailFields.actual_finish_time") }}
                        <span class="red--text">*</span>{{ $t("Global.colon") }}
                      </span>
                      <SearcherDatetime
                        class="my-n2"
                        v-model="stockTakeOrder.actual_finish_time"
                        type="datetime"
                        single-line
                        dense
                        hide-details
                        disabledAfterNow
                        :disabledBeforeSpecifyTime="last_date"
                        required
                        :errors="errors"
                        readonly
                      />
                    </v-card>
                  </ValidationProvider>
                </ValidationObserver>
              </v-col>

              <v-col cols="12" md="4" v-if="isView">
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakes.DetailFields.actual_finish_time")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockTakeOrder.actual_finish_time | formatTime }}
                </v-card>
              </v-col>

              <v-col
                cols="12"
                md="4"
                v-if="
                  !isNew &&
                  shopSettings &&
                  shopSettings.plan_stock_take_enable == 1
                "
              >
                <v-card class="pa-2 text-no-wrap" outlined tile>
                  <span class="secondary--text">
                    {{ $t("StockTakes.Fields.plan_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  {{ stockTakeOrder.plan_name }}
                </v-card>
              </v-col>
               <!-- 选择盘点模板-->
              <v-col cols="12" md="4">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text"  v-if="isNew">
                    {{ $t("TakeTemplates.title")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span class="secondary--text" v-else>
                    {{ $t("StockTakes.Fields.template_name")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <SearcherTakeTemplate 
                    class="my-n1"
                    v-model="takeTemplateSelected"
                    dense
                    noLabel
                    v-if="isNew"
                  />
                  <span v-else>
                    {{stockTakeOrder.template_name}}
                  </span>
                </v-card>
              </v-col>
              <!-- 备注 -->
              <v-col cols="12" md="12">
                <v-card class="pa-2 text-no-wrap d-flex" outlined tile>
                  <span class="secondary--text"
                    >{{ $t("StockTakes.DetailFields.attachment")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <v-text-field
                    v-if="savable"
                    v-model="stockTakeOrder.memo"
                    single-line
                    dense
                    hide-details
                    class="d-inline mt-0 mb-n1"
                  />
                  <span v-else>
                    {{ stockTakeOrder.memo }}
                  </span>
                </v-card>
              </v-col>
              <!-- 附件 -->
              <v-col cols="12" sm="12" md="12">
                <v-card
                  class="pa-2 d-flex overflow-auto text-no-wrap"
                  outlined
                  tile
                >
                  <span class="secondary--text">
                    {{ $t("StockTakes.DetailFields.attachments")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <!-- 上传图片集 -->
                  <span class="ml-4">
                    <v-card
                      height="160"
                      width="240"
                      v-if="album && album.length > 0"
                    >
                      <v-carousel
                        hide-delimiters
                        cycle
                        height="160"
                        width="240"
                      >
                        <v-carousel-item
                          v-for="(item, i) in album"
                          :key="i"
                          :src="item"
                          @click.stop="$showFullscreenImages(album, i)"
                        >
                          <v-tooltip right v-if="savable && item">
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                color="secondary"
                                class="pa-2 float-right"
                                @click.stop="removeFromImages(i)"
                              >
                                fa-times
                              </v-icon>
                            </template>
                            <span> {{ $t("Material.delImg") }}</span>
                          </v-tooltip>
                        </v-carousel-item>
                      </v-carousel>
                    </v-card>
                    <v-file-input
                      ref="imgs_file"
                      v-show="savable"
                      show-size
                      counter
                      small-chips
                      multiple
                      suffix
                      prepend-icon="fa-camera"
                      accept="image/png, image/jpeg"
                      persistent-hint
                      :placeholder="$t('Material.imgsPlaceholder')"
                      :hint="$t('Material.imgsHint')"
                      :rules="imgsRules"
                      v-model="imgs_file"
                    >
                    </v-file-input>
                  </span>
                </v-card>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel v-if="!isNew">
          <v-expansion-panel-header class="py-0">
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab @click.stop="tab = 0">
                {{ $t("ActivityFields.activities") }}
              </v-tab>
            </v-tabs>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-tabs-items v-model="tab">
              <v-tab-item>
                <v-card flat>
                  <v-data-table
                    :headers="activitiesHeaders"
                    :items="stock_out_activities"
                    class="elevation-0"
                    disable-pagination
                    hide-default-footer
                  >
                    <template v-slot:item.created="{ item }">
                      <span class="text-no-wrap">
                        {{ item.created | formatTime }}
                      </span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-card>
        <div v-if="isView">
          <v-tabs v-model="detailTab" background-color="transparent"  class="elevation-2 px-4 mt-4">
            <v-tab @click.stop="detailTab = 0">
              {{ $t("CRUD.details", [$t("StockTakes.ObjectName")]) }}
            </v-tab>
            <v-tab @click.stop="detailTab = 1" v-if="stockTakeCurrentHistories && stockTakeCurrentHistories.length > 0">
              {{ $t("CRUD.details", [$t("StockTakes.historyDetail")]) }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="detailTab">
            <v-tab-item>
              <!-- 盘点明细 -->
              <v-data-table
                id="order_details_table"
                :headers="detailsHeaders"
                :items="stockTakeOrderDetails"
                :search="filter"
                disable-sort
                class="elevation-2 px-4 pb-4"
                disable-pagination
                hide-default-footer
                :no-data-text="$t('StockTakes.DetailNoData')"
              >
                <template v-slot:top>
                  <v-toolbar
                    flat
                    class="transparent-background-color"
                    align-self="center"
                  >
                    <v-row no-gutters class="me-n3">
                      <span class="caption secondary--text pt-2">
                        {{
                          $t(
                              "$vuetify.dataFooter.pageText",
                              stockTakeOrderDetails.length
                                  ? [
                                    1,
                                    stockTakeOrderDetails.length,
                                    stockTakeOrderDetails.length,
                                  ]
                                  : [0, 0, 0]
                          )
                        }}
                      </span>
                      <v-row no-gutters>
                        <v-spacer />
                        <v-col cols="12" sm="9" md="8">
                          <v-text-field
                            v-model="filter"
                            clearable
                            hide-details
                            :label="$t('Search.filter')"
                          />
                        </v-col>
                      </v-row>
                    </v-row>
                  </v-toolbar>
                </template>
                <template v-slot:item.material_img="{ item }">
                  <MaterialThumbnail :material="item.material || item" />
                </template>
                <template v-slot:item.Description="{ item }">
                  <span class="text-no-wrap">
                    {{ item.material_name }}
                  </span>
                  <br />
                  <span v-if="item.standard_name" class="caption secondary--text">
                    {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
                    <span
                      v-if="item.standard_name && item.standard_name.length > 12"
                      :title="item.standard_name"
                      style="cursor: pointer"
                    >
                      {{ item.standard_name.slice(0, 12) + "......" }}
                    </span>
                    <span v-else>
                      {{ item.standard_name }}
                    </span>
                  </span>
                </template>
                <!-- 普通盘点的库存量 -->
                <template v-slot:item.stock_num="{ item }">
                  <!-- <span v-if="$i18n.locale == 'zhHans'">
                    {{ item.stock_num }}
                  </span> -->
                  <!-- <span v-else> -->
                  <span class="text-no-wrap">
                    {{ item.current_count ? item.current_count : 0 }}
                  </span>
                  <span
                    class="text-no-wrap"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ item.unit }}
                  </span>
                </template>
                <!-- 库存量 -->
                <template v-slot:item.sys_count="{ item }">
                  {{ item.sys_count }}{{ item.unit }}
                </template>
                <template v-slot:item.current_count="{ item }">
                  {{ item.current_count }}
                </template>
                <!-- 盘点量 -->
                <template v-slot:item.real_count="{ item }">
                  <span> {{ item.real_count ? item.real_count : 0 }} </span>
                </template>
                <template v-slot:item.stock_take_status="{ item }">
                  <v-chip
                    small
                    label
                    class="ms-4 mt-1"
                    :color="
                      item.sys_count == item.real_count
                        ? 'grey'
                        : item.sys_count > item.real_count
                        ? 'danger'
                        : item.sys_count < item.real_count
                        ? 'primary'
                        : 'gray'
                    "
                    text-color="white"
                  >{{$t(item.sys_count == item.real_count
                          ? "StockTakes.status.stock_take_equality"
                          : item.sys_count > item.real_count
                          ? "StockTakes.status.stock_take_loss"
                          : item.real_count > item.sys_count
                          ? "StockTakes.status.stock_take_profit"
                          : "Status.unkown"
                      )
                    }}
                  </v-chip>
                </template>
                <!-- 单价 -->
                <template v-slot:item.price="{ item }">
                  <span>
                    {{ $t("Global.money") }}
                    {{ item.price | formatMoney }}
                  </span>
                </template>
                <template v-slot:item.show_categories="{ item }">
                  <v-tooltip
                    right
                    v-if="item.show_categories && item.show_categories.length > 0"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{
                          item.show_categories[0].parent_show_category
                              ? item.show_categories[0].parent_show_category.name +
                              " : "
                              : ""
                        }}
                        {{ item.show_categories[0].name }}
                        {{ item.show_categories.length > 1 ? "..." : "" }}
                      </span>
                    </template>
                    <span
                      v-for="(show_category, index) in item.show_categories"
                      :key="show_category.id"
                      class="d-inline"
                    >
                      {{
                        show_category.parent_show_category
                            ? show_category.parent_show_category.name + " : "
                            : ""
                      }}
                      {{
                        show_category.name +
                        (index == item.show_categories.length - 1 ? "" : ",")
                      }}
                    </span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item v-if="stockTakeCurrentHistories && stockTakeCurrentHistories.length > 0">
              <v-data-table
                  id="order_details_table"
                  :headers="currentHistoriesHeaders"
                  :items="stockTakeCurrentHistories"
                  :search="filter"
                  disable-sort
                  class="elevation-2 px-4 pb-4"
                  disable-pagination
                  hide-default-footer
                  :no-data-text="$t('StockTakes.DetailNoData')"
              >
                <template v-slot:top>
                  <v-toolbar
                      flat
                      class="transparent-background-color"
                      align-self="center"
                  >
                    <v-row no-gutters class="me-n3">
                      <span class="caption secondary--text pt-2">
                        {{
                          $t(
                              "$vuetify.dataFooter.pageText",
                              stockTakeCurrentHistories.length
                                  ? [
                                    1,
                                    stockTakeCurrentHistories.length,
                                    stockTakeCurrentHistories.length,
                                  ]
                                  : [0, 0, 0]
                          )
                        }}
                      </span>
                      <v-row no-gutters>
                        <v-spacer />
                        <v-col cols="12" sm="9" md="8">
                          <v-text-field
                            v-model="filter"
                            clearable
                            hide-details
                            :label="$t('Search.filter')"
                          />
                        </v-col>
                      </v-row>
                    </v-row>
                  </v-toolbar>
                </template>
                <template v-slot:item.Description="{ item }">
                  <span class="text-no-wrap">
                    {{ item.material_name }}
                  </span>
                  <br />
                  <span v-if="item.standard_name" class="caption secondary--text">
                    {{ $t("Material.Fields.standard") }}{{ $t("Global.colon") }}
                    <span
                      v-if="item.standard_name && item.standard_name.length > 12"
                      :title="item.standard_name"
                      style="cursor: pointer"
                    >
                      {{ item.standard_name.slice(0, 12) + "......" }}
                    </span>
                    <span v-else>
                      {{ item.standard_name }}
                    </span>
                  </span>
                </template>
                <!-- 原库存量 -->
                <template v-slot:item.stock_num="{ item }">
                  <span class="text-no-wrap">
                    {{ item.stock_num ? item.stock_num : 0 }}
                  </span>
                  <span
                    class="text-no-wrap"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ item.unit }}
                  </span>
                </template>
                <!-- 均价 -->
                <template v-slot:item.avg_price="{ item }">
                  <span>
                    {{ $t("Global.money") }}
                    {{ item.avg_price | formatMoney }}
                  </span>
                </template>
                <!-- 总价 -->
                <template v-slot:item.stock_total="{ item }">
                  <span>
                    {{ $t("Global.money") }}
                    {{ item.stock_total | formatMoney }}
                  </span>
                </template>

              </v-data-table>
            </v-tab-item>
          </v-tabs-items>
        </div>
        <!-- 编辑 -->
        <v-data-table
          v-if="(isNew && !preview) || savable"
          id="order_details_table"
          :headers="detailsHeaders"
          :items="stockTakeOrderDetails"
          :search="filter"
          disable-sort
          class="elevation-2 px-4 mt-4 pb-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('StockTakes.DetailNoData')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{ $t("CRUD.details", [$t("StockTakes.ObjectName")]) }}
              </v-toolbar-title>
              <v-spacer />
              <!-- 导入盘点商品 -->
              <v-btn
                small
                color="print"
                dark
                @click.stop="ImportDialog = true"
                class="ms-1"
                v-if="isNew"
              >
                <v-icon x-small class="pe-1">fa-file-import</v-icon>
                {{ $t("Import.import", [$t("StockTakes.material")]) }}
              </v-btn>
              <!-- 选择商品 -->
              <v-btn
                color="primary"
                small
                dark
                class="ms-1"
                v-if="isNew"
                @click="Dialog = true"
              >
                <v-icon x-small class="pe-1">fa-plus</v-icon>
                {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
              </v-btn>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stockTakeOrderDetails.length
                        ? [
                            1,
                            stockTakeOrderDetails.length,
                            stockTakeOrderDetails.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.material_img="{ item }">
            <MaterialThumbnail :material="item.material || item" />
          </template>
          <template v-slot:item.Description="{ item }">
            <span class="text-no-wrap">
              {{item.material_name}}
            </span>
            <br />
            <span v-if="item.standard_name" class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")
              }}<span
                v-if="item.standard_name && item.standard_name.length > 12"
                :title="item.standard_name"
                style="cursor: pointer"
              >
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
          </template>
          <!-- 普通盘点的库存量 -->
          <template v-slot:item.stock_num="{ item }">
            <!-- <span v-if="$i18n.locale == 'zhHans'">
              {{ item.stock_num }}
            </span> -->
            <!-- <span v-else> -->
            <span class="text-no-wrap">
              {{ item.current_count ? item.current_count : 0 }}
            </span>
            <span
              class="text-no-wrap"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.unit }}
            </span>
          </template>
          <!-- 库存量 -->
          <template v-slot:item.sys_count="{ item }">
            {{ item.sys_count }}{{ item.unit }}
          </template>
          <template v-slot:item.current_count="{ item }">
            {{ item.current_count }}
          </template>
          <!-- 盘点量 -->
          <template v-slot:item.real_count="{ item }">
            <span v-if="isNew || mode == 'stockTake'">
              <span>
                <NumberInput v-model="item.real_count" dense>
                  <template v-slot:append>
                    {{ item.unit }}
                  </template>
                </NumberInput>
              </span>
            </span>
            <span v-else> {{ item.real_count ? item.real_count : 0 }} </span>
          </template>

          <template v-slot:item.stock_take_status="{ item }">
            <v-chip
              small
              label
              class="ms-4 mt-1"
              :color="
                item.sys_count == item.real_count
                  ? 'grey'
                  : item.sys_count > item.real_count
                  ? 'danger'
                  : item.sys_count < item.real_count
                  ? 'primary'
                  : 'gray'
              "
              text-color="white"
              >{{
                $t(
                  item.sys_count == item.real_count
                    ? "StockTakes.status.stock_take_equality"
                    : item.sys_count > item.real_count
                    ? "StockTakes.status.stock_take_loss"
                    : item.real_count > item.sys_count
                    ? "StockTakes.status.stock_take_profit"
                    : "Status.unkown"
                )
              }}
            </v-chip>
          </template>
          <!-- 单价 -->
          <template v-slot:item.price="{ item }">
            <span>
              {{ $t("Global.money") }}
              {{ item.price | formatMoney }}
            </span>
          </template>
          <template v-if="isNew" v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.new"
              small
              text
              class="danger--text pa-0"
              @click.stop="del(item)"
            >
              <v-icon>fa-times</v-icon>
            </v-btn>
          </template>
          <template v-slot:footer>
            <v-row
              v-if="mode == 'regularNew'"
              no-gutters
              align="center"
              class="ps-1 text-no-wrap d-flex"
            >
              <v-col cols="12" md="12" class="px-3">
                <SearcherStockMaterial
                  v-model="addMaterial"
                  :disabledItems="disabledItems"
                  showMaterials
                  label
                />
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.show_categories="{ item }">
            <v-tooltip
              right
              v-if="item.show_categories && item.show_categories.length > 0"
            >
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{
                    item.show_categories[0].parent_show_category
                      ? item.show_categories[0].parent_show_category.name +
                        " : "
                      : ""
                  }}
                  {{ item.show_categories[0].name }}
                  {{ item.show_categories.length > 1 ? "..." : "" }}
                </span>
              </template>
              <span
                v-for="(show_category, index) in item.show_categories"
                :key="show_category.id"
                class="d-inline"
              >
                {{
                  show_category.parent_show_category
                    ? show_category.parent_show_category.name + " : "
                    : ""
                }}
                {{
                  show_category.name +
                  (index == item.show_categories.length - 1 ? "" : ",")
                }}
              </span>
            </v-tooltip>
          </template>
        </v-data-table>
        <!-- 预览：盘盈 -->
        <v-data-table
          v-if="preview && stockTakeHistoryDetails.stockTakeIns.length"
          id="stock_take_profit_table"
          :headers="profitDetailsHeaders"
          :items="stockTakeHistoryDetails.stockTakeIns"
          :search="filter"
          disable-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('StockTakes.DetailNoData')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{
                  $t("CRUD.details", [$t("StockTakes.stockTakeInsObjectName")])
                }}
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stockTakeHistoryDetails.stockTakeIns
                        ? [
                            1,
                            stockTakeHistoryDetails.stockTakeIns.length,
                            stockTakeHistoryDetails.stockTakeIns.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.material_img="{ item }">
            <MaterialThumbnail :material="item.material || item" />
          </template>
          <template v-slot:item.materialDescription="{ item }">
            <span class="text-no-wrap">
              {{item.material_name}}
            </span>
            <br />
            <span v-if="item.standard_name" class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")
              }}<span
                v-if="item.standard_name && item.standard_name.length > 12"
                :title="item.standard_name"
                style="cursor: pointer"
              >
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
          </template>
          <template v-slot:item.positionDescription="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.positionDescription }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.position_bar_code }}
            </span>
          </template>

          <template v-slot:item.in_num_display="{ item }">
            <!-- <span v-if="$i18n.locale == 'zhHans'">
              {{ item.in_num_display }}
            </span>
            <span v-else> -->
            <span class="text-no-wrap">
              {{ item.stock_in_num }}
            </span>
            <span
              class="text-no-wrap"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.stock_unit }}
            </span>
            <!-- </span> -->
          </template>
          <template v-slot:item.production_date="{ item }">
            <SearcherDatetime
              class="my-n2"
              v-model="item.production_date"
              type="date"
              single-line
              dense
              hide-details
              hide-icon
              disabled-after-now
            >
            </SearcherDatetime>
          </template>
          <template v-slot:item.expired_date="{ item }">
            <SearcherDatetime
              class="my-n2"
              v-model="item.expired_date"
              type="date"
              single-line
              dense
              hide-details
              hide-icon
              disabled-before-today
            >
            </SearcherDatetime>
          </template>
          <template v-slot:item.price="{ item }">
            <v-text-field
              v-model="item.price"
              single-line
              dense
              hide-details
              type="number"
              min="0"
              :prefix="$t('Global.money')"
              @blur="
                item.price = $numberFormatter.formatWithDotNoMoreThan(
                  item.price,
                  2
                )
              "
              style="max-width: 80px; margin-left: auto"
            />
            <!-- <span v-else>
              {{ $t("Global.money") }}
              {{ item.price | formatMoney }}
            </span> -->
          </template>
          <template v-slot:item.show_categories="{ item }">
            <v-tooltip
              right
              v-if="item.show_categories && item.show_categories.length > 0"
            >
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{
                    item.show_categories[0].parent_show_category
                      ? item.show_categories[0].parent_show_category.name +
                        " : "
                      : ""
                  }}
                  {{ item.show_categories[0].name }}
                  {{ item.show_categories.length > 1 ? "..." : "" }}
                </span>
              </template>
              <span
                v-for="(show_category, index) in item.show_categories"
                :key="show_category.id"
                class="d-inline"
              >
                {{
                  show_category.parent_show_category
                    ? show_category.parent_show_category.name + " : "
                    : ""
                }}
                {{
                  show_category.name +
                  (index == item.show_categories.length - 1 ? "" : ",")
                }}
              </span>
            </v-tooltip>
          </template>
        </v-data-table>
        <!-- 预览：盘亏 -->
        <v-data-table
          v-if="preview && stockTakeHistoryDetails.stockTakeOuts.length"
          id="stock_take_loss_table"
          :headers="lossDetailsHeaders"
          :items="stockTakeHistoryDetails.stockTakeOuts"
          :search="filter"
          disable-sort
          class="elevation-2 px-4 mt-4"
          disable-pagination
          hide-default-footer
          :no-data-text="$t('StockTakes.DetailNoData')"
        >
          <template v-slot:top>
            <v-toolbar flat class="transparent-background-color">
              <v-toolbar-title class="ms-n2">
                {{
                  $t("CRUD.details", [$t("StockTakes.stockTakeOutsObjectName")])
                }}
              </v-toolbar-title>
            </v-toolbar>
            <v-divider />
            <v-toolbar
              flat
              class="transparent-background-color"
              align-self="center"
            >
              <v-row no-gutters class="me-n3">
                <span class="caption secondary--text pt-2">
                  {{
                    $t(
                      "$vuetify.dataFooter.pageText",
                      stockTakeHistoryDetails.stockTakeOuts
                        ? [
                            1,
                            stockTakeHistoryDetails.stockTakeOuts.length,
                            stockTakeHistoryDetails.stockTakeOuts.length,
                          ]
                        : [0, 0, 0]
                    )
                  }}
                </span>
                <v-row no-gutters>
                  <v-spacer />
                  <v-col cols="12" sm="9" md="8">
                    <v-text-field
                      v-model="filter"
                      clearable
                      hide-details
                      :label="$t('Search.filter')"
                    />
                  </v-col>
                </v-row>
              </v-row>
            </v-toolbar>
          </template>
          <template v-slot:item.material_img="{ item }">
            <MaterialThumbnail :material="item.material || item" />
          </template>
          <template v-slot:item.materialDescription="{ item }">
            <span class="text-no-wrap">
              {{item.material_name}}
            </span>
            <br />
            <span v-if="item.standard_name" class="caption secondary--text">
              {{ $t("Material.Fields.standard") }}{{ $t("Global.colon")
              }}<span
                v-if="item.standard_name && item.standard_name.length > 12"
                :title="item.standard_name"
                style="cursor: pointer"
              >
                {{ item.standard_name.slice(0, 12) + "......" }}
              </span>
              <span v-else>
                {{ item.standard_name }}
              </span>
            </span>
          </template>
          <template v-slot:item.positionDescription="{ item }">
            <span class="text-no-wrap caption font-weight-bold">
              {{ item.positionDescription }}
            </span>
            <br />
            <span
              class="text-no-wrap caption secondary--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.position_bar_code }}
            </span>
          </template>
          <template v-slot:item.production_date="{ item }">
            <span>{{ item.production_date | formatDate }}</span>
          </template>
          <template v-slot:item.expired_date="{ item }">
            <span>{{ item.expired_date | formatDate }}</span>
          </template>
          <template v-slot:item.out_num_display="{ item }">
            <!-- <span v-if="$i18n.locale == 'zhHans'">
              {{ item.out_num_display }}
            </span>
            <span v-else> -->
            <span class="text-no-wrap">
              {{ item.stock_out_num }}
            </span>
            <span
              class="text-no-wrap"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
            >
              {{ item.stock_unit }}
            </span>
            <!-- </span> -->
          </template>
          <template v-slot:item.price="{ item }">
            <!-- <v-text-field
              v-model="item.price"
              single-line
              dense
              hide-details
              type="number"
              min="0"
              :prefix="$t('Global.money')"
              @blur="
                item.price = $numberFormatter.formatWithDotNoMoreThan(
                  item.price,
                  2
                )
              "
              style="max-width: 80px; margin-left: auto"
            /> -->
            <span>
              {{ $t("Global.money") }}
              {{ item.price | formatMoney }}
            </span>
          </template>
          <template v-slot:item.show_categories="{ item }">
            <v-tooltip
              right
              v-if="item.show_categories && item.show_categories.length > 0"
            >
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  {{
                    item.show_categories[0].parent_show_category
                      ? item.show_categories[0].parent_show_category.name +
                        " : "
                      : ""
                  }}
                  {{ item.show_categories[0].name }}
                  {{ item.show_categories.length > 1 ? "..." : "" }}
                </span>
              </template>
              <span
                v-for="(show_category, index) in item.show_categories"
                :key="show_category.id"
                class="d-inline"
              >
                {{
                  show_category.parent_show_category
                    ? show_category.parent_show_category.name + " : "
                    : ""
                }}
                {{
                  show_category.name +
                  (index == item.show_categories.length - 1 ? "" : ",")
                }}
              </span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>

      <StockMaterialsSelectsDialog
        v-model="Dialog"
        @confirm="addMaterials = $event"
        showMaterials
        showCategories
        :disabledItems="disabledItems"
      />
      <ImportExcelAlert
        v-model="ImportDialog"
        :objName="$t('StockTakes.ObjectName')"
        :mode="this.mode"
        @import="
          excelFile = $event;
          importExcel();
        "
      />
    </v-sheet>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import StockTakeOrderActions from "./plugins/Actions";
import StockTakes from "@/api/stock_takes";
import ImportExcelAlert from "./plugins/ImportExcelAlert";
import SearcherStockMaterial from "@/components/plugins/SearcherStockMaterial";
import NumberInput from "@/components/plugins/NumberInput";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import StockMaterialsSelectsDialog from "@/components/plugins/StockMaterialsSelectsDialog";
import MaterialThumbnail from "@/components/plugins/MaterialThumbnail";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import ImportExcelAlert from "./plugins/ImportExcelAlert";
// import DialogAlert from "@/components/plugins/DialogAlert";
import stockOrderAnalyze from "@/api/stock_order_analyze";
import SearcherTakeTemplate from "@/components/plugins/SearcherTakeTemplate";
import TakeMaterialTemplates from "@/api/take_material_templates";
import Files from "@/api/files";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    StockTakeOrderActions,
    SearcherStockMaterial,
    NumberInput,
    SearcherDatetime,
    StockMaterialsSelectsDialog,
    ImportExcelAlert,
    // DialogAlert,
    ValidationObserver,
    ValidationProvider,
    SearcherTakeTemplate,
    MaterialThumbnail,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return (
        !this.preview && (this.mode == "regularNew" || this.mode == "stockTake")
      );
    },
    isNew() {
      return this.mode == "regularNew";
    },
    items() {
      var items = [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.stockManagement"),
          disabled: false,
          href: "/stocks",
        },
        {
          text: i18n.t("Nav.stockTakes"),
          disabled: false,
          href: "/stock-takes",
        },
        {
          text:
            this.mode == "regularNew"
              ? i18n.t("Nav.stockTakeOrderRegularNew")
              : i18n.t("Nav.stockTakeOrderDetail"),
          disabled: true,
        },
      ];
      if (!this.isNew) {
        items.push({
          text:
            this.stockTakeOrder && this.stockTakeOrder.stock_take_code
              ? this.stockTakeOrder.stock_take_code
              : "",
          disabled: false,
          accent: true,
        });
      }
      return items;
    },
    // 编辑table-header
    detailsHeaders() {
      var headers = [];
      //公共
      if (this.accountSettings && this.accountSettings.material_image) {
        headers.push({
          text: i18n.t("StockTakes.DetailFields.material_img"),
          align: "start",
          sortable: false,
          value: "material_img",
        });
      }
      headers.push(
        {
          text: i18n.t("StockTakes.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockTakes.DetailFields.show_categories"),
          align: "start",
          sortable: false,
          value: "show_categories",
        },
        {
          text: i18n.t("StockTakes.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("StockTakes.DetailFields.material"),
          align: "start",
          value: "Description",
        }
      );
      //详情或盘点时
      if (this.isView || this.mode == "stockTake") {
        headers.push({
          text: i18n.t("StockTakes.DetailFields.unit"),
          align: "center",
          value: "unit",
        });
        if (this.stockTakeOrder.status == 2) {
          headers.push({
            text: i18n.t("StockTakes.DetailFields.old_stock_count"),
            align: "end",
            value: "sys_count",
          });
        } else {
          headers.push({
            text: i18n.t("StockTakes.DetailFields.current_stock_count"),
            align: "end",
            value: "sys_count",
          });
        }
        if (this.isView) {
          headers.push({
            text: i18n.t("StockTakes.DetailFields.stock_take_count"),
            align: "center",
            value: "real_count",
          });
        }

        if (this.isView && this.stockTakeOrder.status == 2) {
          headers.push({
            text: i18n.t("StockTakes.DetailFields.status"),
            align: "start",
            value: "stock_take_status",
          });
        }

        if (this.mode == "stockTake") {
          // if (this.$i18n.locale != "zhHans") {
          //   headers.push(
          //     {
          //       text: i18n.t(
          //         "StockTakes.DetailFields.stock_take_count_with_stock_unit"
          //       ),
          //       align: "center",
          //       value: "real_count_rate",
          //     },
          //     {
          //       text: i18n.t(
          //         "StockTakes.DetailFields.stock_take_count_with_default_unit"
          //       ),
          //       align: "center",
          //       value: "real_count_default",
          //     }
          //   );
          // } else {
          headers.push({
            text: i18n.t("StockTakes.DetailFields.stock_take_count"),
            align: "center",
            value: "real_count",
            width: "220",
          });
          // }
        }
      }
      //新建
      if (this.mode == "regularNew") {
        //普通盘点
        headers.push({
          text: i18n.t("StockTakes.DetailFields.current_stock_count"),
          align: "start",
          value: "stock_num",
        });
      }
      if (this.isNew) {
        headers.push(
          {
            text: i18n.t("StockTakes.DetailFields.stock_take_count"),
            align: "center",
            value: "real_count",
          },
          {
            text: i18n.t("TableHeaders.actions"),
            align: "start",
            sortable: false,
            value: "actions",
          }
        );
      }

      return headers;
    },
    // 盘点历史库存
    currentHistoriesHeaders() {
      let headers = [];
      headers.push(
        {
          text: i18n.t("StockTakes.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockTakes.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("StockTakes.DetailFields.material"),
          align: "start",
          value: "Description",
        },
        {
          text: i18n.t("CurrentStocks.Fields.unit"),
          align: "start",
          sortable: false,
          value: "unit",
        },
        {
          text: i18n.t("CurrentStocks.Fields.average_price"),
          align: "start",
          sortable: false,
          value: "avg_price",
        },
        {
          text: i18n.t("CurrentStocks.Fields.current_count"),
          align: "start",
          sortable: false,
          value: "stock_num",
        },
        {
          text: i18n.t("CurrentStocks.Fields.total_price"),
          align: "start",
          sortable: false,
          value: "stock_total",
        },
      );
      return headers
    },
    // 盘盈table-header
    profitDetailsHeaders() {
      var headers = [];

      if (this.accountSettings && this.accountSettings.material_image) {
        headers.push({
          text: i18n.t("StockTakes.DetailFields.material_img"),
          align: "start",
          sortable: false,
          value: "material_img",
        });
      }
      headers.push(
        {
          text: i18n.t("StockTakes.PreviewFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockTakes.DetailFields.show_categories"),
          align: "start",
          sortable: false,
          value: "show_categories",
        },
        {
          text: i18n.t("StockTakes.PreviewFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("StockTakes.PreviewFields.material_name"),
          align: "start",
          width: "450px",
          value: "materialDescription",
        }
      );
      headers.push({
        text: i18n.t("StockTakes.PreviewFields.unit"),
        align: "center",
        value: "stock_unit",
      });
      headers.push({
        text: i18n.t("StockTakes.PreviewFields.profit_num"),
        align: "end",
        value: "in_num_display",
      });
      if (
        this.accountSettings &&
        this.accountSettings.product_date_setting == 1
      ) {
        headers.push(
          {
            text: i18n.t("stockInOrders.DetailFields.production_date"),
            align: "start",
            value: "production_date",
            width: 136,
          },
          {
            text: i18n.t("stockInOrders.DetailFields.expired_date"),
            align: "start",
            value: "expired_date",
            width: 136,
          }
        );
      }
      headers.push({
        text: i18n.t("StockTakes.PreviewFields.price"),
        align: "end",
        value: "price",
      });

      return headers;
    },
    // 盘亏table-header
    lossDetailsHeaders() {
      var headers = [];

      if (this.accountSettings && this.accountSettings.material_image) {
        headers.push({
          text: i18n.t("StockTakes.DetailFields.material_img"),
          align: "start",
          sortable: false,
          value: "material_img",
        });
      }
      headers.push(
        {
          text: i18n.t("StockTakes.PreviewFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("StockTakes.DetailFields.show_categories"),
          align: "start",
          sortable: false,
          value: "show_categories",
        },
        {
          text: i18n.t("StockTakes.PreviewFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("StockTakes.PreviewFields.material_name"),
          align: "start",
          width: "450px",
          value: "materialDescription",
        }
      );
      headers.push({
        text: i18n.t("StockTakes.PreviewFields.unit"),
        align: "center",
        value: "stock_unit",
      });
      headers.push({
        text: i18n.t("StockTakes.PreviewFields.loss_num"),
        align: "end",
        value: "out_num_display",
      });

      return headers;
    },
    stock_id() {
      return this.stockSelected
        ? this.stockSelected.id
        : this.stockTakeOrder
        ? this.stockTakeOrder.stock_id
        : null;
    },
    stock_area_id() {
      return this.stockAreaSelected ? this.stockAreaSelected.id : null;
    },
    stock_position_id() {
      return this.stockPositionSelected ? this.stockPositionSelected.id : null;
    },
    material_id() {
      return this.addMaterial ? this.addMaterial.material_id : null;
    },
    operate_user_id() {
      return this.accountUser ? this.accountUser.id : null;
    },
    stockPositionItems() {
      return this.stockPosition.map((position) => {
        var Description = i18n.t("MovePositionOrder.DetailFields.position", [
          position.position_code,
          position.position_name,
        ]);
        if (this.stock && this.stock.position_name_display) {
          if (this.stock.position_name_display.indexOf(2) > -1) {
            Description = position.position_name;
          }
          if (
            this.stock.position_name_display.indexOf(4) > -1 &&
            position.stock_roadway
          ) {
            Description = position.stock_roadway.code + " - " + Description;
          }
          if (
            this.stock.position_name_display.indexOf(3) > -1 &&
            position.stock_area
          ) {
            Description = position.stock_area.area_name + " - " + Description;
          }
        }
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.position_id == position.id
            )
          : false;
        return Object.assign({}, position, { Description, disabled });
      });
    },
    activitiesHeaders: () => [
      {
        text: i18n.t("ActivityFields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
      {
        text: i18n.t("ActivityFields.content"),
        align: "start",
        sortable: false,
        value: "content",
      },
      {
        text: i18n.t("ActivityFields.operater"),
        align: "start",
        sortable: false,
        value: "operater_name",
      },
    ],
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["accountUser", "accountSettings", "shopSettings"]),
  },

  data: () => ({
    panels: [0],
    tab: null,
    detailTab: null,
    filter: "",
    mode: "",
    preview: false,
    stock_out_activities: [],
    stockTakeOrder: {},
    stockTakeOrderDetails: [],
    stockTakeCurrentHistories: [],
    stockSelected: null,
    stock: null,
    executeUser: null,
    stockPosition: [],
    stockPositionSelected: null,
    stockAreaSelected: null,
    addMaterial: null,
    addMaterialSearch: "",
    addPositionMaterialSelected: null,
    addPositionMaterialSearch: "",
    stockBatchDialog: false,
    stockBatchSeleted: [],
    stockBatchSeletedId: [],
    stockTakeHistoryDetails: [],
    disabledItems: [],
    ImportDialog: false,
    excelFile: null,
    stockDetailsNullDialog: false,
    addMaterials: [],
    Dialog: false,
    last_date: null,
    takeTemplateSelected:null,
    imgs_file: [],
    imgsRules: [
      (value) =>
        !value ||
        value.filter((v) => v.size >= 10000000).length == 0 ||
        i18n.t("Material.imgsHint"),
    ],
    album: []
  }),

  mounted() {
    if (this.$route.path.startsWith("/stock-takes/detail/regular-new")) {
      this.mode = "regularNew";
    } else {
      this.mode = this.$route.params.mode;
      if (this.mode)
        this.$router.replace("/stock-takes/detail/" + this.$route.params.id);
    }
    stockOrderAnalyze.getLastDate().then(
      function (response) {
        if (response.data.status.isOK()) {
          this.last_date = response.data.last_date;
        }
      }.bind(this)
    );
  },

  methods: {
    getStockInsFromAPI() {
      StockTakes.fetchOne(this.$route.params.id, {
        readonly: 1,
        order_activity: 1,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stockTakeOrder = response.data.stock_take;
            // 继承接口下发的附件（独立副本，页面删除与提交数据源互不影响）
            this.album = response.data.stock_take.img
              ? response.data.stock_take.img.slice()
              : [];
            if (this.stockTakeOrder.stock_take_current_histories && this.stockTakeOrder.stock_take_current_histories.length > 0) {
              this.stockTakeCurrentHistories = this.stockTakeOrder.stock_take_current_histories
            }
            this.stock_out_activities = response.data.order_activities;
          }
        }.bind(this)
      );
    },
    del(item) {
      this.stockTakeOrderDetails.splice(
        this.stockTakeOrderDetails.findIndex((detail) =>
          item.id
            ? item.id == detail.id
            : item.material_id == detail.material_id &&
              (item.new ? item.new == detail.new : detail.new == 0)
        ),
        1
      );
      this.disabledItems.splice(
        this.disabledItems.findIndex(
          (dis) => item.material_id == dis.material_id
        )
      );
    },
    previewMethod(data) {
      if (this.mode == "stockTake") return StockTakes.addStockTakeView(data);
      else if (this.mode == "edit") return "edit";
    },
    // 提交方法
    submitMethod(data) {
      if (this.isNew) return StockTakes.addStockTake(data);
      else if (this.mode == "stockTake") return StockTakes.stockTake(data);
    },
    //新增预览
    async doPreview() {
      this.$store.dispatch("fullscreenLoading");
      // 检查图片上传的error，拒绝提交
      if (this.$refs.imgs_file && this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      var previewDetails = this.newSubmitData();
      if (previewDetails) {
        this.previewMethod(previewDetails).then(
          async function (response) {
            if (response.data.status.isOK()) {
              this.stockTakeHistoryDetails =
                response.data.stock_take_history.stock_take_history_details;
              if (
                this.stockTakeHistoryDetails.stockTakeIns.length ||
                this.stockTakeHistoryDetails.stockTakeOuts.length
              ) {
                this.preview = true;
                this.stockTakeOrder.actual_finish_time = this.stockTakeOrder.created
                this.stockTakeHistoryDetails.stockTakeIns.forEach(
                  (stock_take_ins) => {
                    //商品名称格式化
                    stock_take_ins.materialDescription = i18n.t(
                      "Material.materialNameWithCodeAndStandard",
                      [
                        stock_take_ins.material_code,
                        stock_take_ins.material_name,
                        stock_take_ins.standard_name &&
                        stock_take_ins.standard_name.length > 12
                          ? stock_take_ins.standard_name.slice(0, 12) + "......"
                          : stock_take_ins.standard_name,
                      ]
                    );
                  }
                );
                this.stockTakeHistoryDetails.stockTakeOuts.forEach(
                  (stock_take_outs) => {
                    //商品名称格式化
                    stock_take_outs.materialDescription = i18n.t(
                      "Material.materialNameWithCodeAndStandard",
                      [
                        stock_take_outs.material_code,
                        stock_take_outs.material_name,
                        stock_take_outs.standard_name &&
                        stock_take_outs.standard_name.length > 12
                          ? stock_take_outs.standard_name.slice(0, 12) +
                            "......"
                          : stock_take_outs.standard_name,
                      ]
                    );
                  }
                );
                this.$store.dispatch("fullscreenLoadingStop");
              } else {
                // 无差异：直接提交盘点，携带备注与附件（继承接口下发的老数据）
                var imgNames = await this.uploadImgs();
                if (imgNames === null) {
                  this.$store.dispatch("fullscreenLoadingStop");
                  return;
                }
                var directData = Object.assign({}, previewDetails, {
                  memo: this.stockTakeOrder.memo,
                  img: this.oldImgNames().concat(imgNames),
                });
                this.submitMethod(directData)
                  .then(
                    function (response) {
                      if (response.data.status.isOK()) {
                        this.$router.push("/stock-takes");
                      }
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  )
                  .catch(
                    function () {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  );
              }
            }
          }.bind(this)
        );
      } else {
        this.$store.dispatch("fullscreenLoadingStop");
      }
    },
    //新增提交
    async doSubmit() {
      this.$store.dispatch("fullscreenLoading");
      // 检查图片上传的error，拒绝提交
      if (this.$refs.imgs_file && this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      if (this.isNew) {
        // 新建提交：上传本次新增附件，携带备注一并提交
        var newImgNames = await this.uploadImgs();
        if (newImgNames === null) {
          this.$store.dispatch("fullscreenLoadingStop");
          return;
        }
        var submitData = this.newSubmitData();
        if (submitData) {
          submitData = Object.assign(submitData, {
            memo: this.stockTakeOrder.memo,
            img: newImgNames,
          });
          this.submitMethod(submitData)
            .then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$router.push("/stock-takes");
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            )
            .catch(
              function () {
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
        } else {
          this.$store.dispatch("fullscreenLoadingStop");
        }
      } else if (this.mode == "stockTake") {
        this.$refs.observer.validate().then(
          async function (result) {
            if (result) {
              var stockTakeArr = this.newSubmitData();
              if (stockTakeArr) {
                // 盘点单均为已创建单据：提交时携带备注与附件，并继承接口下发的老数据
                var imgNames = await this.uploadImgs();
                if (imgNames === null) {
                  this.$store.dispatch("fullscreenLoadingStop");
                  return;
                }
                var stock_take_img = this.oldImgNames();
                imgNames.forEach((img_name) => stock_take_img.push(img_name));
                stockTakeArr = Object.assign(stockTakeArr, {
                  memo: this.stockTakeOrder.memo,
                  img: stock_take_img,
                });
                this.submitMethod(stockTakeArr)
                  .then(
                    function (response) {
                      if (response.data.status.isOK()) {
                        this.$router.push("/stock-takes");
                      }
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  )
                  .catch(
                    function () {
                      this.$store.dispatch("fullscreenLoadingStop");
                    }.bind(this)
                  );
              } else {
                this.$store.dispatch("fullscreenLoadingStop");
              }
            } else {
              this.$store.dispatch("fullscreenLoadingStop");
            }
          }.bind(this)
        );
      }
    },
    newSubmitData() {
      //过滤没有盘点量的详情
      var submitOrderDetails = {
        stock_take_id: this.stockTakeOrder.id,
        // stock_id: this.stock_id,
        // operate_user_id: this.operate_user_id,
        stock_take_history_details: [],
      };
      if (this.takeTemplateSelected) { 
        submitOrderDetails = Object.assign(submitOrderDetails, {template_id: this.takeTemplateSelected.id,})
      }

      if (this.isNew) {
        this.stockTakeOrderDetails.forEach((order_detail) => {
          let newData = [];
          if (this.isNew && this.mode == "regularNew") {
            newData = Object.assign(
              {},
              {
                material_code: order_detail.material_code,
                real_count: order_detail.real_count,
              }
            );
          }

          submitOrderDetails.stock_take_history_details.push(newData);
        });
        return submitOrderDetails;
      } else if (this.preview && this.mode == "stockTake") {
        //提交盘点
        let orderDetails = [];
        //盘盈
        this.stockTakeHistoryDetails.stockTakeIns.map((detail) => {
          //添加详情
          let newData = {
            material_code: detail.material_code,
            real_count: detail.real_count,
            // material_code: detail.material_code,
            price: detail.price,
          };
          if (
            this.accountSettings &&
            this.accountSettings.product_date_setting == 1
          ) {
            newData = Object.assign({}, newData, {
              production_date: detail.production_date,
              expired_date: detail.expired_date,
            });
          }
          // if (detail.stock_detail_id) {
          //   newData = Object.assign(newData, {
          //     stock_detail_id: detail.stock_detail_id,
          //   });
          // }

          orderDetails.push(newData);
        });
        //盘亏
        this.stockTakeHistoryDetails.stockTakeOuts.map((detail) => {
          let newData = {
            material_code: detail.material_code,
            real_count: detail.real_count,
            // material_code: detail.material_code,
            //  price: detail.price,
          };
          orderDetails.push(newData);
        });
        // 整理盘平的商品
        this.stockTakeOrderDetails.map((d) => {
          if (!orderDetails.find((e) => e.material_code == d.material_code)) {
            //添加详情
            let newData = {
              material_code: d.material_code,
              real_count: d.real_count,
            };

            orderDetails.push(newData);
          }
        });
        submitOrderDetails.stock_take_history_details = orderDetails;
        submitOrderDetails.actual_finish_time =
          this.stockTakeOrder.actual_finish_time;
        return submitOrderDetails;
      } else {
        //提交到预览
        let orderDetails = this.stockTakeOrderDetails.filter(
          (detail) => detail.real_count || detail.real_count === 0
        );
        if (orderDetails.length) {
          orderDetails.forEach((order_detail) => {
            //添加详情
            let newData = {
              material_code: order_detail.material_code,
              real_count: order_detail.real_count,
            };

            submitOrderDetails.stock_take_history_details.push(newData);
          });

          return submitOrderDetails;
        }
      }
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      if (this.mode == "regularNew") {
        //普通盘点导入
        StockTakes.importCommonTemplate(this.excelFile)
          .then(
            function (response) {
              if (response.data.status.isOK()) {
                this.$snackbar.info(
                  i18n.t("Import.success", [i18n.t("StockTakes.ObjectName")])
                );
                this.ImportDialog = false;
                var id = response.data.stock_take.id;
                this.$router.push("/stock-takes/detail/" + id + "/stockTake");
              }
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          )
          .catch(
            function () {
              this.$store.dispatch("fullscreenLoadingStop");
            }.bind(this)
          );
      }
    },
    async doEdit() {
      this.$store.dispatch("fullscreenLoading");
      // 检查图片上传的error，拒绝提交
      if (this.$refs.imgs_file && this.$refs.imgs_file.hasError) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      var submitData = this.newSubmitData();
      if (!submitData) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      var details = submitData.stock_take_history_details.map((detail) => {
        return {
          material_code: detail.material_code,
          real_count: detail.real_count,
        };
      });
      // 盘点单均为已创建单据：提交时携带备注与附件，并继承接口下发的老数据
      var imgNames = await this.uploadImgs();
      if (imgNames === null) {
        this.$store.dispatch("fullscreenLoadingStop");
        return;
      }
      var stock_take_img = this.oldImgNames();
      imgNames.forEach((img_name) => stock_take_img.push(img_name));
      StockTakes.editStockTake({
        stock_take_id: submitData.stock_take_id,
        stock_take_history_details: details,
        memo: this.stockTakeOrder.memo,
        img: stock_take_img,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push("/stock-takes");
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    removeFromImages(i) {
      var oldCount = this.stockTakeOrder.img
        ? this.stockTakeOrder.img.length
        : 0;
      if (i < oldCount) {
        // 删除的是接口下发的老附件
        this.stockTakeOrder.img.splice(i, 1);
        this.album.splice(i, 1);
      } else {
        // 删除的是新选择的文件，album 交由 imgs_file 监听重建
        this.imgs_file.splice(i - oldCount, 1);
      }
    },
    // 接口下发的老附件为完整url，提交时仅取文件名
    oldImgNames() {
      return (this.stockTakeOrder.img || []).map((url) =>
        url.substring(url.lastIndexOf("/") + 1)
      );
    },
    // 上传本次新增附件，返回 img_name 数组；上传异常返回 null，调用方需中止提交
    async uploadImgs() {
      var imgNames = [];
      if (this.imgs_file && this.imgs_file.length > 0) {
        try {
          let response = await Files.shopFilesUpload(
            this.imgs_file,
            "shop_images"
          );
          if (response.data.status.isOK()) {
            response.data.data.forEach((img) => imgNames.push(img.img_name));
          }
        } catch (error) {
          return null;
        }
      }
      return imgNames;
    },
  },

  watch: {
    $route(to) {
      if (to.params.mode) {
        this.mode = to.params.mode;
        this.$router.replace("/stock-takes/detail/" + to.params.id);
      }
    },
    mode: {
      handler() {
        if (this.isNew) {
          this.stockTakeOrder = {
            stock_order_details: [],
          };
          this.stockTakeOrder.actual_date = this.$datetimeUtils.formatTime(
            new Date()
          );
        } else if (this.$route.params.id) {
          this.getStockInsFromAPI();
        }
      },
    },
    stockTakeOrder: {
      handler() {
        this.stockTakeOrderDetails =
          this.stockTakeOrder && this.stockTakeOrder.stock_take_details
            ? this.stockTakeOrder.stock_take_details
            : [];
        // this.stock =
        //   this.stockTakeOrder && this.stockTakeOrder.stock
        //     ? this.stockTakeOrder.stock
        //     : {};
      },
    },
    stockTakeOrderDetails: {
      handler() {
        this.stockTakeOrderDetails.map((detail) => {
          detail.Description = i18n.t(
            "Material.materialNameWithCodeAndStandard",
            [
              detail.material_code,
              detail.material_name,
              detail.standard_name && detail.standard_name.length > 12
                ? detail.standard_name.slice(0, 12) + "......"
                : detail.standard_name,
            ]
          );
        });
        //普通盘点
        if (this.mode == "regularNew") {
          this.stockTakeOrderDetails.forEach((detail) => {
            var isFind = this.disabledItems.findIndex(
              (item) => item.material_id == detail.material_id
            );
            if (isFind == -1) {
              this.disabledItems.push(detail);
            }
          });
          //清空商品select
          if (this.addMaterial) {
            this.addMaterial = {};
          }
        }
      },
    },
    stockSelected: {
      handler() {},
    },

    stockAreaSelected: {
      handler() {
        this.stockPositionSelected = null;
      },
    },

    addMaterial: {
      handler() {
        if (Object.keys(this.addMaterial).length) {
          if (this.mode == "regularNew") {
            var newData = JSON.parse(JSON.stringify(this.addMaterial));
            newData.price = newData.supply_price;
            newData.new = this.stockTakeOrderDetails.length + 1;
            this.stockTakeOrderDetails.push(newData);
          }
        }
      },
    },
    addMaterials: {
      handler() {
        this.addMaterials.forEach((addMaterial) => {
          if (Object.keys(addMaterial).length) {
            if (this.mode == "regularNew") {
              var newData = JSON.parse(JSON.stringify(addMaterial));
              newData.price = newData.supply_price;
              newData.new = this.stockTakeOrderDetails.length + 1;
              this.stockTakeOrderDetails.push(newData);
            }
          }
        });
      },
    },
    takeTemplateSelected: {
      handler() { 
        if (this.takeTemplateSelected) { 
          TakeMaterialTemplates.fetch(
            this.takeTemplateSelected.id,
            { readonly: 1, limit: this.$consts.limitAll }).then(
            function (response) {
                if (response.data.status.isOK()) {
                  this.stockTakeOrderDetails = []
                  response.data.take_template_details.forEach((newData) => { 
                    newData.new = this.stockTakeOrderDetails.length + 1;
                    this.stockTakeOrderDetails.push(newData)
                  })
                }
              }.bind(this)
          );
        }
      }
    },
    imgs_file: {
      deep: true,
      handler() {
        // 接口下发的老附件在前，新选择的图片预览追加在后
        var oldImgs = this.stockTakeOrder.img
          ? this.stockTakeOrder.img.slice()
          : [];
        if (this.imgs_file.length) {
          // 附件总数（老附件 + 新选择文件）不超过三张
          if (oldImgs.length + this.imgs_file.length > 3) {
            this.$snackbar.error(i18n.t("Examine.DetailFields.hint"));
            this.imgs_file = [];
          } else {
            this.album = oldImgs;
            this.imgs_file.forEach((img) => {
              var reader = new FileReader();
              reader.readAsDataURL(img);
              let that = this;
              reader.onload = function () {
                that.album.push(this.result);
              };
            });
          }
        } else {
          this.album = oldImgs;
        }
      },
    }
  },
};
</script>